export enum Keys {
  userSignIn = "1",
  userSignInMobile = "um",
  userSignInEmail = "ue",
}
export const set = (key: Keys, value: any): void => {
  localStorage?.setItem(key, JSON.stringify(value));
};

export const get = (key: Keys): any => {
  let val = localStorage?.getItem(key);
  val = val ? JSON.parse(val) : null;
  return val;
};
export const remove = (key: Keys): any => {
  localStorage?.removeItem(key);
};

const redirectKey = "sign_in_redirect";
export const setRedirect = (redirect: string) => {
  sessionStorage.setItem(redirectKey, redirect);
};

export const getRedirect = (): string | null => {
  return sessionStorage.getItem(redirectKey);
};

export const clearRedirect = () => {
  return sessionStorage.removeItem(redirectKey);
};
